import React from 'react'
// import "./About_page_section_2.css"
import AboutSection from"./Aboutsectiontwo.module.css"

function Aboutsectiontwo() {
    return (
        <div>
            <div className={AboutSection.sectiontwo}>
                    <p> <b>APHRODITE </b> is a software application developed with the aim of matching people to make meaningful relationships. We help those who are generally term picky with high standards and we call them self-aware persons to meet their partners based
                            on their preferences. The application is target at users within the age range of 18-50.
                            <br /><br /> We use GPS technology and the government's database to confirm users’ identity; to ensure all users are safe with no sinister motive. We ensure proper authentication of documents to prevent catfishing.
                            <br /><br /> Our application features a survey which will be updated periodically to capture changing social needs of our users, while matching them with users of common interest.
                            <br />We offer membership by purchasing several subscription options. Membership offers extra perks, special customizations, more prospects, as well as invites to exclusive events. They last 1 week, 1 month, 3 months, 6 months, or 12
                            months, and automatically renew or at intervals or cancelled
                    </p>        
            </div>

        </div>
    )
}

export default Aboutsectiontwo;
